import {useRef, useCallback} from 'react';

const TYPING_POLL_INTERVAL_MS = 4000;

const notifyVisitorTyping = (sessionId: string) => {
    fetch(`/inbox/agent-typing/1?sessionId=${sessionId}`, {method: 'POST'});
};

/**
 * Debounced typing notification that polls every 4s while the user is actively typing.
 * Twin logic lives in chat-footer.js.
 */
export function useTypingNotification(sessionId: string | null | undefined) {
    const isTyping = useRef<boolean>(false);
    const hasNotified = useRef<boolean>(false);

    const notifyTyping = useCallback(() => {
        if (!sessionId) return;

        if (!hasNotified.current) {
            hasNotified.current = true;
            notifyVisitorTyping(sessionId);
            const poll = () => {
                setTimeout(() => {
                    if (isTyping.current) {
                        isTyping.current = false;
                        notifyVisitorTyping(sessionId);
                        poll();
                    } else {
                        hasNotified.current = false;
                    }
                }, TYPING_POLL_INTERVAL_MS);
            };

            poll();
        } else {
            isTyping.current = true;
        }
    }, [sessionId]);

    return {notifyTyping};
}
